import React, { useState } from 'react'
import Video from './Video'

const VideoCall = () => {
	return (
		<Video />
	)
}

export default VideoCall;